import React from 'react';
import PropTypes from 'prop-types';

import {
  ContainerIcon,
  DateTextWrapper,
  DayBoxHeader,
  DayName,
  Header,
  Icon,
} from './styles';

import {
  FORMAT_DATE,
  FORMAT_DAY_NAME,
  FORMAT_MONTH_DAY,
} from './constants';

const HeaderShow = (props) => {
  const {
    daysOfWeek,
    onNextDay,
    onPreviousDay,
    today,
    totalDays,
  } = props;

  return (
    <Header>
      {
        daysOfWeek.map((date, index) => (
          <DayBoxHeader key={date.format(FORMAT_DATE)}>
            {index === 0 && !today.isSame(date.startOf('day')) && (
              <ContainerIcon left>
                <Icon
                  size="big"
                  tabIndex="0"
                  onClick={onPreviousDay}
                  name="chevron left"
                  aria-label="Select previous day"
                  role="button"
                />
              </ContainerIcon>
            )}
            <DateTextWrapper>
              <DayName>
                {date.format(FORMAT_DAY_NAME)}
              </DayName>
              <DayName>
                {date.format(FORMAT_MONTH_DAY)}
              </DayName>
            </DateTextWrapper>

            {index === totalDays - 1 && (
              <ContainerIcon right>
                <Icon
                  size="big"
                  tabIndex="0"
                  onClick={onNextDay}
                  name="chevron right"
                  aria-label="Select next day"
                  role="button"
                />
              </ContainerIcon>
            )}
          </DayBoxHeader>
        ))
      }
    </Header>
  );
};

HeaderShow.propTypes = {
  daysOfWeek: PropTypes.oneOfType([PropTypes.array]).isRequired,
  totalDays: PropTypes.number.isRequired,
  onPreviousDay: PropTypes.func.isRequired,
  onNextDay: PropTypes.func.isRequired,
  today: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default HeaderShow;
